/**
 * What the status probe and the account requests share in telling the page's own mistakes from the network's
 * (ADR-078's amendment of 2026-10-04): a check that an address and its options make a request before it is sent,
 * and the line a failed request is logged by.
 */

/**
 * Checks that an address and its options make a request, by making one that is never sent. `fetch` rejects a bad
 * address or option with the same `TypeError` it rejects a refused connection with, so the page checks first, and
 * what `fetch` then rejects is the network's doing.
 *
 * @param url The address.
 * @param init The options.
 * @throws TypeError when they make no request.
 */
export function requestable(url: string, init: RequestInit): void {
  void new Request(url, init);
}

/**
 * An error as a log line names it: its name and message, which carry no address, query or body.
 *
 * @param error What was thrown.
 * @returns Such as "TypeError: Failed to fetch".
 */
export function errorLine(error: unknown): string {
  return error instanceof Error ? `${error.name}: ${error.message}` : "an error of no known kind";
}
